/** Query string of a partner link: `t` carries the link token. */
export interface PartnerLinkSearch {
  t?: string
}

/** Keep only a non-empty string token; drop anything else in the query. */
export function validatePartnerLinkSearch(search: Record<string, unknown>): PartnerLinkSearch {
  return typeof search.t === 'string' && search.t !== '' ? { t: search.t } : {}
}
